export function clearNullValues(obj) {
  const newObj = {};
  for (const key in obj) {
    if (obj[key] !== null) newObj[key] = obj[key];
  }
  return newObj;
}

export function clearEmptyValues(obj) {
  const newObj = {};
  for (const key in obj) {
    if (obj[key] && obj[key] !== '') newObj[key] = obj[key];
  }
  return newObj;
}

export function clearNullishValues(obj) {
  const newObj = {};
  for (const key in obj) {
    const value = obj[key];
    if (value !== null && value !== undefined) newObj[key] = value;
  }
  return newObj;
}
